import adminModule from "../admin.module"

adminModule.directive('uploadProgressBar', () => ({
  restrict: 'E',
  scope: {
    total: '=',
    current: '=',
    status: '=',
    title: '='
  },
  template: `
    <h4>{{title}}</h4>
    <div class="progress">
        <div class="progress-bar" role="progressbar" style="width:{{current * 100 / total}}%"></div>
    </div>
    <div><em>{{status}}</em></div>
  `,
}))
